/** Кастомный текст для paywall (лимит семьи). Две строки. */
export const PAYWALL_ADD_CHILD_CUSTOM_MESSAGE =
  "У вас больше одного ребёнка? 👶\n\nВ бесплатной версии доступен один профиль\nВ полной — можно добавить всю семью";
